import { Stack } from '../../../../../../design-system/stack/stack';
import { XeroFeature, XeroFeatureLineItem } from './xero-feature-line-item';

const xeroFeatures: XeroFeature[] = ['SYNC_TRANSACTIONS', 'SEND_INVOICES', 'RECONCILIATION'];

export const XeroFeaturesCard = () => {
  return (
    <Stack space={6} align="stretch" className="rounded-lg bg-muted p-6">
      {xeroFeatures.map((feature) => (
        <XeroFeatureLineItem key={feature} feature={feature} />
      ))}
    </Stack>
  );
};
